<div class="position-relative">
  <app-element-loader
    [loadingStatus]="loadingPriceGridStatus"
    [loadingMessage]="loadingPriceGridMessage"
  >
  </app-element-loader>

  <div
    class="detail-section"
    [class.detail-section--fix-height-price-grid]="
      loadingPriceGridStatus || allSolutions?.length > 0
    "
  >
    <h4 class="detail-section__title">Cabine</h4>
    <div
      *ngIf="
        !loadingPriceGridStatus &&
        (!allSolutions || (allSolutions && allSolutions.length === 0))
      "
    >
      <div class="alert alert-warning">
        Nessuna cabina disponibile per questa crociera
      </div>
    </div>
    <div *ngIf="allSolutions?.length > 0" class="c-detail-steps-solution">
      <div class="c-detail-steps-solution__wrapper">
        <h6>Mese:</h6>
        <div class="c-detail-steps-solution__months">
          <span
            *ngFor="let month of availablesMonths"
            (click)="month !== selectedMonth && selectMonth(month)"
            [class.active]="month === selectedMonth"
          >
            {{ month }}
          </span>
        </div>
      </div>
    </div>
    <div *ngIf="allSolutions?.length > 0" class="c-detail-price-grid">
      <div class="c-detail-price-grid__cabins">
        <div class="c-detail-price-grid__dates">
          <span>&nbsp;</span>
        </div>
        <!-- ciclo le cabine -->
        <div
          *ngFor="let cabinType of allSolutions | cruiseCabinsGroupedByType"
          class="c-detail-price-grid__cabins-item"
        >
          <span>{{ cabinType.type }}</span>
        </div>
      </div>
      <swiper
        [config]="config"
        [(index)]="indexGrid"
        id="boxGridCabin"
        class="c-detail-price-grid__choices"
      >
        <!-- ciclo le solutions raggruppate per data di partenza e arrivo -->
        <div
          *ngFor="
            let solutionsGroupedByDate of allSolutions
              | cruiseSolutionsGroupedByDate
              | keyvalue
          "
          class="slide c-detail-price-grid__col"
        >
          <!-- date -->
          <div class="c-detail-price-grid__dates">
            <span class="range-dates"
              ><small>dal</small>
              {{
                $any(solutionsGroupedByDate.key.split("|")[0]) | dayjs : "DD/MM"
              }}
              <small>al</small>
              {{
                $any(solutionsGroupedByDate.key.split("|")[1]) | dayjs : "DD/MM"
              }}</span
            >
          </div>
          <!-- fine date -->
          <!-- racchiudo tutto in un container per poter ciclare ogni riga che rappresenta il tipo di cabina -->
          <ng-container
            *ngFor="
              let cabinType of allSolutions | cruiseCabinsGroupedByType;
              index as index
            "
          >
            <!-- se non esistono cabine di quel tipo specifico, allora visualizzo una casella vuota per lasciare ordinata la griglia -->
            <div
              *ngIf="!solutionsGroupedByDate.value.cabinsGroupedByType[index]"
              class="c-detail-price-grid__price-item not-available-empty"
            ></div>
            <!-- ... altrimenti, proseguo e visualizzo il prezzo della bestCabin del tipo specifico nella casella della griglia -->
            <div
              *ngIf="solutionsGroupedByDate.value.cabinsGroupedByType[index]"
              (click)="
                selectSolution(
                  $any(solutionsGroupedByDate.value),
                  solutionsGroupedByDate.value.cabinsGroupedByType[index]
                    .bestCabin,
                  true,
                  true
                )
              "
              class="c-detail-price-grid__price-item"
              [ngClass]="{
                active:
                  solutionsGroupedByDate.value.cabinsGroupedByType[index]
                    .bestCabin.id === selectedCabin?.id,
                disabled:
                  !solutionsGroupedByDate.value.cabinsGroupedByType[index]
                    .bestCabin.available ||
                  !solutionsGroupedByDate.value.cabinsGroupedByType[index]
                    .bestCabin.availability
              }"
            >
              <div class="c-detail-price-grid__price">
                <small>da</small>
                {{
                  solutionsGroupedByDate.value.cabinsGroupedByType[index]
                    .bestCabin.price | number : "1.0-0"
                }}
                €
                <small
                  *ngIf="
                    !solutionsGroupedByDate.value.cabinsGroupedByType[index]
                      .bestCabin.available ||
                    !solutionsGroupedByDate.value.cabinsGroupedByType[index]
                      .bestCabin.availability
                  "
                  class="d-inline-block"
                >
                  non disponibile
                </small>
              </div>
            </div>
          </ng-container>
        </div>
      </swiper>
    </div>
  </div>
  <!-- mostro la sezione di info cabine per tipo + selezione tariffe -->
  <section *ngIf="selectedSolution && selectedCabin" class="detail-section">
    <h4 class="detail-section__title">{{ selectedCabin.type }}</h4>
    <div class="card-accomodation">
      <div
        class="booking-card-accomodation__container card-accomodation__container"
      >
        <div class="card-accomodation__main">
          <!-- sezione galleria immagini cabine -->
          <div class="card-accomodation__images">
            <swiper [config]="configCabin" [(index)]="indexCabin">
              <div
                *ngFor="
                  let imagePath of selectedCabin
                    | allCabinImagesByType : (shipService$ | async)
                "
                class="slide card-accomodation__images-item"
              >
                <img
                  class="img-cover"
                  height="270"
                  width="100%"
                  [src]="imagePath"
                  [alt]="selectedCabin.type"
                  [showPlaceholderOnError]="true"
                />
              </div>
            </swiper>
          </div>
          <!-- sezione card info tipologia cabine -->
          <div
            class="card-accomodation__content card-accomodation__content-cabin"
          >
            <div class="card-accomodation__content-info">
              <label
                >dal {{ selectedSolution.departureDate | dayjs : "DD/MM" }} al
                {{ selectedSolution.arrivalDate | dayjs : "DD/MM" }}</label
              >
              <h6>
                <i class="icon-user pe-1"></i>
                <span
                  [innerHTML]="
                    (
                      selectedCabin
                      | allCabinInfoByTypeFromShipservice
                        : (shipService$ | async)
                    ).subtitle
                  "
                >
                  <i class="icon-arrow-right"></i>
                </span>
              </h6>
              <div
                class="card-accomodation__description"
                [innerHTML]="
                  (
                    selectedCabin
                    | allCabinInfoByTypeFromShipservice : (shipService$ | async)
                  ).description
                "
              ></div>
              <span
                class="card-accomodation__surface"
                [innerHTML]="
                  (
                    selectedCabin
                    | allCabinInfoByTypeFromShipservice : (shipService$ | async)
                  ).surface
                "
              >
              </span>
            </div>
            <div class="card-accomodation__content-price">
              <div class="card-accomodation__cabin-price">
                da <span>{{ selectedCabin.price | number : "1.0-0" }} €</span>
              </div>
              <div class="card-accomodation__fare-and-cta">
                <span class="card-accomodation__fare">
                  <span>
                    {{
                      (
                        selectedCabin
                        | cabinDescriptionByFare : tourOperatorId
                        | async
                      )?.label || selectedCabin.fare
                        ? "Tariffa"
                        : "Cabina"
                    }}:
                  </span>
                  <span>
                    {{
                      (
                        selectedCabin
                        | cabinDescriptionByFare : tourOperatorId
                        | async
                      )?.label ||
                        selectedCabin.fare ||
                        selectedCabin.description +
                          (selectedCabin.code
                            ? " (" + selectedCabin.code + ")"
                            : "")
                    }}
                  </span>
                </span>
                <a
                  class="card-accomodation__cta"
                  (click)="openCabin = !openCabin"
                >
                  <span *ngIf="!openCabin"
                    >Vedi le
                    {{
                      (
                        selectedCabin
                        | cabinDescriptionByFare : tourOperatorId
                        | async
                      )?.label || selectedCabin.fare
                        ? "tariffe"
                        : "cabine"
                    }}
                    <i class="icon-chevron-down"></i
                  ></span>
                  <span *ngIf="openCabin"
                    >Nascondi le
                    {{
                      (
                        selectedCabin
                        | cabinDescriptionByFare : tourOperatorId
                        | async
                      )?.label || selectedCabin.fare
                        ? "tariffe"
                        : "cabine"
                    }}
                    <i class="icon-chevron-up"></i
                  ></span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- sezione dedicata alla selezione delle tariffe cabina disponibili -->
        <div
          *ngIf="openCabin"
          class="card-accomodation__room o-room__more"
          [class.card-accomodation__room--open]="openCabin"
        >
          <div class="o-room__more-body mb-1">
            <div class="o-room__more-info">
              <h5 class="h5">
                {{
                  (
                    selectedCabin
                    | cabinDescriptionByFare : tourOperatorId
                    | async
                  )?.label || selectedCabin.fare
                    ? "Tariffa"
                    : "Cabina"
                }}
                selezionata
              </h5>
            </div>
          </div>
          <div class="o-room__solutions mb-4 position-relative">
            <!-- ciclo le tariffe disponibili -->
            <swiper [config]="configFares" [(index)]="indexFares">
              <div
                *ngFor="
                  let cabin of cabinsByTypeSelected
                    | removeDuplicateCabins
                    | orderBy : 'price';
                  index as index
                "
                class="slide list-item"
              >
                <div
                  class="o-room-solution "
                  [ngClass]="{
                    disabled: isCabinDisabled(cabin)
                  }"
                >
                  <div class="o-room-solution__header position-relative">
                    <label
                      class="form-check ps-0 stretched-link"
                      for="cabinFareRadio_fare_{{ index }}"
                    >
                      <input
                        class="form-check-input"
                        type="radio"
                        id="cabinFareRadio_fare_{{ index }}"
                        name="cabinSelected_fare"
                        [value]="cabin.id + '_' + cabin.code + '_' + cabin.fare"
                        [(ngModel)]="selectedCabinForRadioBtn"
                        (change)="selectCabin(cabin)"
                      />
                      <h6 class="form-check-label">
                        &nbsp;
                        {{
                          (
                            cabin
                            | cabinDescriptionByFare : tourOperatorId
                            | async
                          )?.label ||
                            cabin.fare ||
                            cabin.description +
                              (cabin.code ? " (" + cabin.code + ")" : "")
                        }}
                        <small *ngIf="!cabin.available || !cabin.availability"
                          ><br /><i>Non disponibile</i></small
                        >
                      </h6>
                    </label>
                    <!-- dato che alcune cabine non hanno il fare e sull'etichetta della radio se questo non è presente, si prende la description...
                    quindi, aggiungo questo elemento p solo se è presente il fare e la description della cabina -->
                    <p
                      *ngIf="cabin.fare && cabin.description"
                      class="pl-0"
                      [class.mb-1]="
                        cabin?.categoryDescription &&
                        cabin.openCatDesc &&
                        cabin.available &&
                        cabin.availability
                      "
                    >
                      <i
                        *ngIf="
                          cabin?.categoryDescription &&
                          cabin.available &&
                          cabin.availability
                        "
                        title="Informazioni categoria cabina"
                        class="info-cat-desc icon-info"
                        (click)="cabin.openCatDesc = !cabin.openCatDesc"
                      ></i>
                      {{
                        cabin.description +
                          (cabin.code ? " (" + cabin.code + ")" : "")
                      }}
                    </p>
                    <p
                      *ngIf="cabin.openCatDesc"
                      class="pt-1 pb-1 pl-0 border-top border-bottom"
                      [innerHTML]="cabin?.categoryDescription"
                    ></p>
                  </div>
                  <div
                    *ngIf="
                      (cabin | cabinDescriptionByFare : tourOperatorId | async)
                        ?.elements?.length > 0
                    "
                  >
                    <div
                      class="o-room-solution__body"
                      [ngClass]="{
                        'o-room-solution__body--open': cabin.openText
                      }"
                    >
                      <ul class="u-list--fare">
                        <li
                          *ngFor="
                            let element of (
                              cabin
                              | cabinDescriptionByFare : tourOperatorId
                              | async
                            )?.elements
                          "
                        >
                          {{ element }}
                        </li>
                      </ul>
                    </div>
                    <!-- Mostro la cta per espandere la mini card solo se ci sono piu di 4 elementi nell'array dedicato alle info cabina -->
                    <a
                      *ngIf="
                        (
                          cabin
                          | cabinDescriptionByFare : tourOperatorId
                          | async
                        )?.elements?.length > 4
                      "
                      class="o-room-solution__more"
                      (click)="cabin.openText = !cabin.openText"
                      style="z-index: 10"
                    >
                      <span *ngIf="!cabin.openText">Mostra più info</span>
                      <span *ngIf="cabin.openText">Nascondi info</span>
                    </a>
                  </div>
                  <div
                    *ngIf="
                      (cabin | cabinDescriptionByFare : tourOperatorId | async)
                        ?.description
                    "
                    class="o-room-solution__tag"
                  >
                    <span
                      >{{
                        (
                          cabin
                          | cabinDescriptionByFare : tourOperatorId
                          | async
                        )?.description
                      }}
                    </span>
                  </div>
                  <div class="o-room-solution__footer d-flex align-items-center justify-content-between">
                    <ng-container *ngFor="let promoKey of activePromos | filterByPromo:cabin">
                      <span
                            [ngClass]="getPromoCssClass(promoKey)"
                            class="mt-1 me-0 mb-2"
                            >
                        <span class="p-1 fs-xs">{{PROMO_CODES[promoKey].label}}</span>
                      </span>
                    </ng-container>
                    <div class="prices">
                      <h6 class="h6 price">
                        € {{ cabin.price | number : "1.0-0" }}
                      </h6>
                      <span
                        class="pp"
                        *ngIf="
                        (cabin.isUpdatedFromCategory ||
                          selectedSolution.isPriceUpdatedFromCategory) &&
                        occupancy?.guests
                      "
                      >
                      per {{ occupancy.guests }} passeggeri
                    </span>
                      <span
                        class="pp"
                        *ngIf="
                        (cabin.isUpdatedFromCategory ||
                          selectedSolution.isPriceUpdatedFromCategory) &&
                        !occupancy?.guests
                      "
                      >
                      totale
                    </span>
                      <span
                        class="pp"
                        *ngIf="
                        !cabin.isUpdatedFromCategory &&
                        !selectedSolution.isPriceUpdatedFromCategory
                      "
                      >
                      per persona
                    </span>
                    </div>
                  </div>
                </div>
              </div>
            </swiper>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
